import styled from 'styled-components'

const StepSubHeadlineUi = styled.div`
  font-size: 12px;  
`

export default StepSubHeadlineUi